import { render, staticRenderFns } from "./AdminProfile.vue?vue&type=template&id=bfbcf88e&"
import script from "./AdminProfile.vue?vue&type=script&lang=js&"
export * from "./AdminProfile.vue?vue&type=script&lang=js&"
import style0 from "./AdminProfile.vue?vue&type=style&index=0&id=bfbcf88e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports